<template>
  <my-giving-layout>
    <div class="bg-[#F6F4F0] w-full min-h-screen px-[24px] flex flex-col items-center text-center">
      <!-- Content container - vertically centered -->
      <div class="flex-1 flex flex-col items-center justify-center pb-[200px]">
        <img src="/assets/images/my-giving/rcsuccess.png" alt="Top Image" class="w-32 h-32 mb-4" />

        <div>
          <h1 class="text-[2.5rem] leading-[2.75rem] font-black text-[#2B2926] tracking-[-1.2px]">
            Request is being<br />processed
          </h1>
        </div>
        <p
          class="text-[1rem] leading-[2.0625rem] text-[#2B2926] mt-[24px] px-[16px] text-center leading-tight"
        >
          Account will be removed from
          <span class="font-semibold text-[#1C1C1C]">Manage My<br />Giving</span>in a few minutes.
          We'll notify you<br />when it's completed. All recurring giving<br />arrangements have
          already been removed.
        </p>
        <p class="mt-[16px] text-center leading-tight">
          For any queries, you may reach out to
          <a
            href="mailto:accounts@heartofgodchurch.org"
            class="text-[#4F46E5] underline underline-offset-4 font-medium hover:opacity-80"
            >accounts@heartofgodchurch.org</a
          >
        </p>
      </div>

      <div
        class="absolute bottom-[32px] mt-[32px] w-[90%] max-w-[600px] left-1/2 -translate-x-1/2 flex flex-col gap-[16px]"
      >
        <div
          @click="goToManageAccounts"
          class="border-[2px] border-[#42362B] w-full bg-[#F6F4F0] text-[#21201E] text-[1rem] md:text-[1.375rem] lg:text-[1.5rem] font-semibold rounded-[100px] py-[14px] md:py-[18px] lg:py-[20px] text-center"
        >
          See Status
        </div>

        <BottomButton
          id="generate-qr-code"
          text="Back to MyGiving"
          :disabled="isButtonDisabled"
          :fontSize="16"
          @click="goToManageGiving"
          class="w-full mb-[0px]"
        />
      </div>
    </div>
  </my-giving-layout>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
import MyGivingLayout from '@/components/MyGivingLayout.vue';
import { Browser } from '@capacitor/browser';
import { isNativeNotWeb } from '@/utils/platform-check';

export default {
  name: 'RemoveBank',
  components: {
    BottomButton,
    MyGivingLayout,
  },
  data() {
    return {
      isButtonDisabled: false,
    };
  },
  methods: {
    goToManageAccounts() {
      this.$router.replace('/my-giving/manage#accounts');
    },
    goToManageGiving() {
      this.$router.replace('/my-giving');
    },
  },
  async ionViewWillEnter() {
    if (isNativeNotWeb()) {
      try {
        await Browser.close();
      } catch (error) {
        if (!error?.message?.includes('No active window')) {
          console.error('[RemoveBank] Error closing browser:', error);
        }
      }
    }
  },
};
</script>
